import script from "./sub-title.vue?vue&type=script&setup=true&lang=js"
export * from "./sub-title.vue?vue&type=script&setup=true&lang=js"

import "./sub-title.vue?vue&type=style&index=0&id=7abe355c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abe355c"]])

export default __exports__